import React from "react";

export const FormLabelRequiredAsterisk: React.FC = () => {
    return (<span className={"text-danger"}>*</span>)
}
